module.exports = __webpack_public_path__ + "static/greybunny6-7fe031434f87744decc64a7a3e3570e6.png";